import { FC } from 'react'

import { Controller, useForm } from 'react-hook-form'
import { message } from 'antd'
import { yupResolver } from '@hookform/resolvers/yup'
import styled, { useTheme } from 'styled-components'

import { PrimaryInput } from 'src/Components/PrimaryInput'
import { FullWideNotification } from 'src/Components/FullWideNotification'
import { CTAButton } from 'src/Components/Buttons/CTAButton'
import { sendEmailToResetPassword } from 'src/Redux/auth-process/emailPasswordSlice/api-actions'
import { useAppDispatch } from 'src/Hooks/redux'

import { schema, FormData } from './helpers'

const StyledCTAButton = styled(CTAButton)`
  width: fit-content;
  margin: 0 auto;
  padding-left: 40px;
  padding-right: 40px;
  margin-bottom: 16px;
`
export const ForgotPasswordFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ForgotPasswordForm: FC = () => {
  const theme = useTheme()
  const [messageApi, contextHolder] = message.useMessage()
  const dispatch = useAppDispatch()
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
  })

  const onSubmit = handleSubmit(({ email }) => {
    void dispatch(sendEmailToResetPassword(email))
      .unwrap()
      .then((res) => {
        void messageApi.open({
          content: (
            <FullWideNotification message='Please check your email and click on the provided link to reset your password.' />
          ),
          duration: 3,
          style: { backgroundColor: theme.color.brandGreen },
        })
        return res
      })
      .catch(() => {
        void messageApi.open({
          content: (
            <FullWideNotification message="Sorry, we couldn't find an account with that email or it was signed up via Spotify." />
          ),
          duration: 3,
          style: { backgroundColor: theme.color.mediumRed },
        })
      })
  })

  return (
    <ForgotPasswordFormContainer onSubmit={onSubmit}>
      <Controller
        name='email'
        control={control}
        defaultValue=''
        render={({ field: { onChange } }) => (
          <PrimaryInput
            {...register('email')}
            name='email'
            type='email'
            autoComplete='off'
            error={errors?.email?.message}
            placeholder={'Email'}
            onChange={onChange}
          />
        )}
      />

      <StyledCTAButton type='submit'>Reset Password</StyledCTAButton>

      {contextHolder}
    </ForgotPasswordFormContainer>
  )
}
